import { ActiveOrderData } from '../../types';
import { ActiveOrder } from './ActiveOrder/ActiveOrder';

interface ActiveOrdersProps {
	orders: ActiveOrderData[];
}

export const ActiveOrders = ({ orders }: ActiveOrdersProps) => {
	return (
		<div className="active-orders-container">
			{orders.map((order) => (
				<ActiveOrder key={order.id} order={order} />
			))}
		</div>
	);
};
